// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-form-field {
   width: 100%
}
.mat-dialog-content {
   overflow: auto;
}
.error {
   font-size: 12px;
   margin-top: -15px;
   text-align: left;
   color: red;
}
mat-dialog-actions{
   margin-top: 12px;
   padding-bottom: 15px;
}

@media (min-width: 800px) {
   .two-column-edit {
      height: 200px;
      max-width: 800px;
   }

   .two-column-edit .column {
      float: left;
      width: 50%;
   }

   .two-column-edit .etax-column {
      border-left: 1px solid #e5e5e5;
   }
}

@media (min-width: 800px) {
   .two-column {
      height: 200px;
      max-width: 800px;
   }

   .two-column .column {
      float: left;
      width: 50%;
   }

   .two-column .etax-column {
      border-left: 1px solid #e5e5e5;
   }
}

.column {
   padding: 0px 15px;
   max-width: 400px;
}

.file-list {
   font-size: 12px;
   list-style: none;
   margin: 8px 0;
   padding: 0;
}

.file-list li {
   line-height: 24px;
   padding-right: 24px;
   position: relative;
}

.file-list .file-name {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}

.file-list .file-size {
   font-size: 11px;
}

.file-list mat-icon {
   color: #999;
   cursor: pointer;
   font-size: 20px;
   width: 20px;
   height: 20px;
   position: absolute;
   top: 2px;
   right: 0;
   opacity: 0;
   transition: opacity .1s, color .4s;
}

.file-list li:hover mat-icon {
   opacity: 1;
}

.file-list mat-icon:hover {
   color: #d32f2f;
}
.upload-button {
   border: 1px solid #00bcd4;
   color: #00b2c9;
   line-height: normal;
}

.upload-button i, .upload-button span {
   display: inline-block;
   vertical-align: middle;
}

.upload-button input[type=file] {
   display: none;
   overflow: hidden;
   width: 0;
   height: 0;
}
.inactive {
   color: #ccc;
}
.hint {
   color: #FFA726;
   font-size: 11px;
}

.input-right { 
   text-align: right; 
}
`, "",{"version":3,"sources":["webpack://./src/app/account/register-company-dialog/register-company-dialog.component.css"],"names":[],"mappings":"AAAA;GACG;AACH;AACA;GACG,cAAc;AACjB;AACA;GACG,eAAe;GACf,iBAAiB;GACjB,gBAAgB;GAChB,UAAU;AACb;AACA;GACG,gBAAgB;GAChB,oBAAoB;AACvB;;AAEA;GACG;MACG,aAAa;MACb,gBAAgB;GACnB;;GAEA;MACG,WAAW;MACX,UAAU;GACb;;GAEA;MACG,8BAA8B;GACjC;AACH;;AAEA;GACG;MACG,aAAa;MACb,gBAAgB;GACnB;;GAEA;MACG,WAAW;MACX,UAAU;GACb;;GAEA;MACG,8BAA8B;GACjC;AACH;;AAEA;GACG,iBAAiB;GACjB,gBAAgB;AACnB;;AAEA;GACG,eAAe;GACf,gBAAgB;GAChB,aAAa;GACb,UAAU;AACb;;AAEA;GACG,iBAAiB;GACjB,mBAAmB;GACnB,kBAAkB;AACrB;;AAEA;GACG,mBAAmB;GACnB,gBAAgB;GAChB,uBAAuB;AAC1B;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,WAAW;GACX,eAAe;GACf,eAAe;GACf,WAAW;GACX,YAAY;GACZ,kBAAkB;GAClB,QAAQ;GACR,QAAQ;GACR,UAAU;GACV,kCAAkC;AACrC;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,cAAc;AACjB;AACA;GACG,yBAAyB;GACzB,cAAc;GACd,mBAAmB;AACtB;;AAEA;GACG,qBAAqB;GACrB,sBAAsB;AACzB;;AAEA;GACG,aAAa;GACb,gBAAgB;GAChB,QAAQ;GACR,SAAS;AACZ;AACA;GACG,WAAW;AACd;AACA;GACG,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB","sourcesContent":[".mat-form-field {\n   width: 100%\n}\n.mat-dialog-content {\n   overflow: auto;\n}\n.error {\n   font-size: 12px;\n   margin-top: -15px;\n   text-align: left;\n   color: red;\n}\nmat-dialog-actions{\n   margin-top: 12px;\n   padding-bottom: 15px;\n}\n\n@media (min-width: 800px) {\n   .two-column-edit {\n      height: 200px;\n      max-width: 800px;\n   }\n\n   .two-column-edit .column {\n      float: left;\n      width: 50%;\n   }\n\n   .two-column-edit .etax-column {\n      border-left: 1px solid #e5e5e5;\n   }\n}\n\n@media (min-width: 800px) {\n   .two-column {\n      height: 200px;\n      max-width: 800px;\n   }\n\n   .two-column .column {\n      float: left;\n      width: 50%;\n   }\n\n   .two-column .etax-column {\n      border-left: 1px solid #e5e5e5;\n   }\n}\n\n.column {\n   padding: 0px 15px;\n   max-width: 400px;\n}\n\n.file-list {\n   font-size: 12px;\n   list-style: none;\n   margin: 8px 0;\n   padding: 0;\n}\n\n.file-list li {\n   line-height: 24px;\n   padding-right: 24px;\n   position: relative;\n}\n\n.file-list .file-name {\n   white-space: nowrap;\n   overflow: hidden;\n   text-overflow: ellipsis;\n}\n\n.file-list .file-size {\n   font-size: 11px;\n}\n\n.file-list mat-icon {\n   color: #999;\n   cursor: pointer;\n   font-size: 20px;\n   width: 20px;\n   height: 20px;\n   position: absolute;\n   top: 2px;\n   right: 0;\n   opacity: 0;\n   transition: opacity .1s, color .4s;\n}\n\n.file-list li:hover mat-icon {\n   opacity: 1;\n}\n\n.file-list mat-icon:hover {\n   color: #d32f2f;\n}\n.upload-button {\n   border: 1px solid #00bcd4;\n   color: #00b2c9;\n   line-height: normal;\n}\n\n.upload-button i, .upload-button span {\n   display: inline-block;\n   vertical-align: middle;\n}\n\n.upload-button input[type=file] {\n   display: none;\n   overflow: hidden;\n   width: 0;\n   height: 0;\n}\n.inactive {\n   color: #ccc;\n}\n.hint {\n   color: #FFA726;\n   font-size: 11px;\n}\n\n.input-right { \n   text-align: right; \n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
